import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { parseQuerystring } from "../../../Code/Utilities"
import { RedBar } from "../../"
import Step1 from "./Step1"
import Step2 from "./Step2"
import styles from "./styles.module.scss"

import { useUserData } from "../../../Context/user"

function Steps({ setSuccess, redeemCodeFromParams, charityIdFromParams }) {
  const [multiRedeem, setMultiRedeem] = useState(false)
  const [step, setStep] = useState(0)
  const { loggedInUser } = useUserData()
  const STEPS = [Step1, Step2]
  const { pathname } = useLocation()
  const { RCAE, RC, CHARITYID } = parseQuerystring(window.location.search.toUpperCase())
  const [codes, setCodes] = useState([])


  useEffect(() => {
    const isMulti = pathname.includes("/multi")
    setMultiRedeem(isMulti)
  }, [pathname])

  const handleContinue = () => {
    setStep(step + 1)
  }
  const handleBack = () => {
    setStep(step - 1)
  }

  const handleMultiRedeem = () => {
    //history.push(`/Redeem/multi/${window.location.search}`)
    window.location = `/Redeem/multi/${window.location.search}`;
  }

  const StepComponent = STEPS[step]

  return (
    <>
      <RedBar>
        <div className={styles.stepLabel}>
          Step {step + 1} of {STEPS.length}
          {!multiRedeem && !step && (
            <div
              className={styles.btnMultiRedeem}
              onClick={handleMultiRedeem}>
              Redeem Multiple Codes
            </div>
          )}
        </div>
      </RedBar>

      <StepComponent
        onContinue={handleContinue}
        onBack={handleBack}
        setSuccess={setSuccess}
        loggedInUser={loggedInUser}
        codeAsEntered={!!RCAE ? RCAE : (redeemCodeFromParams || RC)}
        rc={(redeemCodeFromParams || RC)}
        codes={codes}
        setCodes={setCodes}
        charityId={(charityIdFromParams
          ? parseInt(charityIdFromParams)
          : (CHARITYID
            ? parseInt(CHARITYID)
            : undefined))}
        multi={multiRedeem}
        setMultiRedeem={setMultiRedeem} />
    </>
  )
}

export default Steps
